import React, { Component } from "react";
import "./editSharelist.scss";
import { Button, Container, ListGroup, Form, Navbar, Nav} from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import ApiV2 from "../../common/apiV2";


class EditSharelist extends Component{
    constructor(props) {
        super(props);
        this.state = {
            toggleState: false,
            selectedRecs: [],
            placeIds: [],
        };
    }

    async componentDidMount(){

        if(this.props.selectedSharelist.places){
            this.setState({
                placeIds: this.props.selectedSharelist.places.map(function(place) {return(place.id);})
            })
        }
    }

    async saveSharelistUpdates(){
        try {
            await ApiV2.addSharelistPlaces(this.props.selectedSharelist.data.id, this.state.selectedRecs);
            this.props.notifyInfo(
                "Successfully updated Sharelist places"
            );
        } catch(e) {
            console.log("Error: " + JSON.stringify(e));
            this.props.notifyFailure(
                "Failed to update Sharelist places"
            );
        }
    }

    toggleRec(id){
        var temp = document.getElementById(id);

        if (temp.className === "list-group-item"){
            temp.className = "list-group-item active"
            let tempRecs = this.state.selectedRecs;
            tempRecs.push(id);
            this.setState({selectedRecs: tempRecs});
        } else {
            temp.className = "list-group-item"
            let tempRecs = this.state.selectedRecs.filter(e => e !== id);
            this.setState({selectedRecs: tempRecs});
        }
    }

    renderRecommendations() {
        if (Array.isArray(this.props.userRecs)){
            const places = this.props.userRecs.map(place => {
                let isActive = false;
                if (this.state.placeIds.includes(place.id)){
                    // isActive = true;
                    return;
                }
                return(
                    <ListGroup.Item key={place.id} id={place.id} active={isActive} onClick={() => this.toggleRec(place.id)}>
                        {place.name}
                    </ListGroup.Item>
                    
                );
            });
            return places;
        }
    }

    render() {
        return(
            <Container>
        <Navbar expand="lg" bg="light" variant="light" sticky="top" className="top-nav nav-fill">
            <Nav>
                <Nav.Link className="p-0">
                    <Button variant="link" onClick={() => this.props.history.goBack()}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </Button>
                </Nav.Link>
            </Nav>
            <Navbar.Brand className="brand">{this.props.selectedSharelist.data?.name}</Navbar.Brand>
            <Nav>
                {/* placeholder */}
            </Nav>
        </Navbar>
                <ListGroup className="mt-2">
                    {this.renderRecommendations()}
                </ListGroup>
                    <Button className="mt-2 w-100" onClick={async () => this.saveSharelistUpdates()}>Save</Button>
            </Container>
        );
    }
}

export default withRouter(EditSharelist)

EditSharelist.propTypes = {
    selectedSharelist: PropTypes.object.isRequired,
    userRecs: PropTypes.array.isRequired,
    notifyInfo: PropTypes.func.isRequired,
    notifyFailure: PropTypes.func.isRequired
};
  

